export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-300">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-lg font-bold">
                  瓜
                </span>
                <span className="font-heading text-xl text-background-50">吃瓜爆料网</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                全网最全娱乐八卦爆料平台，提供吃瓜爆料网入口、官网首页、最新地址发布，2025吃瓜爆料网站导航，快速直达热门爆料内容。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-100 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                <a href="#hero" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  首页
                </a>
                <a href="#features" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  平台特色
                </a>
                <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  热度榜单
                </a>
                <a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  最新动态
                </a>
                <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  常见问题
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-100 mb-4">热门话题</h4>
              <div className="flex flex-col gap-2">
                <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  顶流塌房
                </a>
                <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  综艺黑幕
                </a>
                <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  网红翻车
                </a>
                <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  明星恋情
                </a>
                <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  娱乐圈资本
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-100 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-500 leading-relaxed">
                合作伙伴信息即将上线，敬请期待。
              </p>
            </div>
          </div>

          <div className="border-t border-background-700/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2025 吃瓜爆料网 — 本网站内容仅供娱乐参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <a href="#faq" className="hover:text-primary-400 transition-colors">用户协议</a>
              <a href="#faq" className="hover:text-primary-400 transition-colors">隐私政策</a>
              <a href="#contact" className="hover:text-primary-400 transition-colors">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}